Number.isFinite =
	Number.isFinite ||
	function(value) {
		return typeof value === 'number' && isFinite(value);
	};



// WEBPACK FOOTER //
// ./src/polyfills.js